import { render, staticRenderFns } from "./QualityGaps.vue?vue&type=template&id=0089ed26"
import script from "./QualityGaps.vue?vue&type=script&lang=js"
export * from "./QualityGaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports